// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__25RGW","list":"styles_list__35m1X"};